import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@app/router';
import { trackEvent, EVENTS } from '@app/segment';
import { useIsNonInteractiveViewer } from '@app/ui';
import { useInitiateUserLogin } from '@app/user';

interface LoggedOutNavProps {
  buttonSize?: string;
  buttonPadding?: string;
}

const LoggedOutNav = ({
  buttonSize = 'md',
  buttonPadding = undefined,
}: LoggedOutNavProps) => {
  const { t } = useTranslation();
  const initiateUserLogin = useInitiateUserLogin();
  const isNonInteractiveViewer = useIsNonInteractiveViewer();

  return (
    <>
      <li key="account-login" style={{ listStyleType: 'none' }}>
        <ButtonLink
          variant="secondary"
          size={buttonSize}
          padding={buttonPadding}
          fontSize="md"
          _hover={{ color: 'neutral.white', bgColor: 'neutral.black' }}
          onClick={() => {
            trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
              label: t('Login'),
            });
            initiateUserLogin('login', { state: { forceLogin: true } });
          }}
          id="nav-login"
          to={isNonInteractiveViewer ? '/login' : ''}
        >
          {t('Login')}
        </ButtonLink>
      </li>

      <li key="account-signup" style={{ listStyleType: 'none' }}>
        <ButtonLink
          variant="primary"
          size={buttonSize}
          padding={buttonPadding}
          fontSize="md"
          color="neutral.white"
          to={isNonInteractiveViewer ? '/signup' : ''}
          id="nav-signup"
          onClick={() => {
            trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
              label: t('Highlighted Sign Up'),
            });
            initiateUserLogin('signup', { state: { forceLogin: true } });
          }}
        >
          {t('Sign Up')}
        </ButtonLink>
      </li>
    </>
  );
};

export default LoggedOutNav;
